import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-botswana-personal-loan.component.scss';
var CalculatorBotswanaPersonalLoan = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorBotswanaPersonalLoan, _super);
    function CalculatorBotswanaPersonalLoan(element) {
        return _super.call(this, element) || this;
    }
    CalculatorBotswanaPersonalLoan.prototype.init = function () {
        this.varInsuranceRate = 0.55;
        this.varOriginationRate = 2.10;
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputLoanAmount = this.element.querySelector('input[name=loan_amount]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.totalMonthly = this.element.querySelector('.js-monthly');
        this.totalInterest = this.element.querySelector('.js-interest-total');
        this.totalTerm = this.element.querySelector('.js-term-total');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-botswana-personal-loan__result--terms');
        // this.containerSchedule = document.querySelector('.js-amort-schedule-business-loan-calculator');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        // this.calculate();
        // TooltipsService.initTooltips();
    };
    CalculatorBotswanaPersonalLoan.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            _this.totalMonthly.innerHTML = "-";
            _this.totalInterest.innerHTML = "-";
            _this.totalTerm.innerHTML = "-";
        });
    };
    CalculatorBotswanaPersonalLoan.prototype.calculate = function () {
        var amortArray = [];
        var loanAmount = parseFloat(this.inputLoanAmount.value);
        var term = parseFloat(this.inputTerm.value);
        var interestRate = parseFloat(this.inputInterest.value);
        var pmt = -this.PMT(interestRate / 1200, term, loanAmount, 0, 0);
        var month = parseFloat(this.inputTerm.value);
        var totalEstimation = 0;
        var totalInterest = 0;
        for (var index = 0; index < term; index++) {
            // No insurance calculation
            var insuranceRateValue = 0;
            var calcMonthInterest = loanAmount * (interestRate / 1200); // monthly rate
            var calcMonthPrincipal = pmt - calcMonthInterest;
            totalInterest += calcMonthInterest;
            totalEstimation += pmt;
            var lineItem = {
                month: month,
                principal: calcMonthPrincipal,
                interest: calcMonthInterest,
                insurancerate: insuranceRateValue,
                totalPayment: pmt,
                pmt: pmt,
                balance: loanAmount - calcMonthPrincipal,
                totalAccumulated: totalEstimation
            };
            loanAmount -= calcMonthPrincipal;
            month -= 1;
            amortArray.push(lineItem);
        }
        console.log(amortArray);
        this.totalMonthly.innerHTML = this.roundFormatter(pmt, 2, true);
        this.totalInterest.innerHTML = interestRate.toFixed(2) + "%";
        this.totalTerm.innerHTML = term + " Months";
        // this.calculateAmort();
    };
    // calculateAmort() {
    // 	this.containerSchedule.innerHTML = '';
    // 	let loanAmount = parseFloat(this.inputLoanAmount.value);
    // 	let term = parseFloat(this.inputTerm.value);
    // 	let interestRate = parseFloat(this.inputInterest.value);
    // 	let pmt = -this.PMT(interestRate / 1200, term, loanAmount, 0, 0); // Monthly payment
    // 	let amortArray: any[] = [];
    // 	let balance = loanAmount;
    // 	let month = 0;
    // 	let totalInstallment = 0;
    // 	let totalInterest = 0;
    // 	let totalPrincipal = 0;
    // 	let totalStampDuty = 0;
    // 	// Loop exactly for the user-entered term
    // 	for (let i = 0; i < term; i++) {
    // 		month += 1;
    // 		let interest = balance * (interestRate / 100) / 12;
    // 		let principal = pmt - interest;
    // 		let newBalance = balance - principal;
    // 		// Stamp duty calculated as 0.0000002 * balance (rounded to 2 decimals)
    // 		let stampDuty = this.round(interest * 0.00002, 2);
    // 		let lineItem = {
    // 			month: month,
    // 			loanAmount: balance,
    // 			monthlyInstallment: pmt,
    // 			installment: interest,
    // 			stampDuty: stampDuty,
    // 			principal: principal,
    // 			balance: newBalance
    // 		};
    // 		totalInstallment += pmt;
    // 		totalInterest += interest;
    // 		totalPrincipal += principal;
    // 		totalStampDuty += stampDuty;
    // 		amortArray.push(lineItem);
    // 		balance = newBalance;
    // 	}
    // 	// Build output HTML
    // 	let output = `
    // 		<table class="table table--blue table-responsive table-striped static_header">
    // 			<thead>
    // 				<tr>
    // 					<th>Term</th>
    // 					<th>Initial Capital</th>
    // 					<th>Installment</th>
    // 					<th>Stamp Duty</th>
    // 					<th>Amortised Capital</th>
    // 					<th>Final Capital</th>
    // 				</tr>
    // 			</thead>
    // 			<tbody>`;
    // 	for (const row of amortArray) {
    // 		output += `
    // 			<tr>
    // 				<td>${row.month}</td>
    // 				<td>${this.formatter(this.round(row.loanAmount, 2))}</td>
    // 				<td>${this.formatter(this.round(row.installment, 2))}</td>
    // 				<td>${row.stampDuty.toFixed(2)}</td>
    // 				<td>${this.formatter(this.round(row.principal, 2))}</td>
    // 				<td>${this.formatter(this.round(row.balance, 2))}</td>
    // 			</tr>`;
    // 	}
    // 	output += `
    // 			</tbody>
    // 			<tfoot>
    // 				<tr>
    // 					<th>Total</th>
    // 					<th>-</th>
    // 					<th>${this.formatter(this.round(totalInstallment, 2))}</th>
    // 					<th>${this.formatter(this.round(totalInterest, 2))}</th>
    // 					<th>${this.formatter(this.round(totalStampDuty, 2))}</th>
    // 					<th>${this.formatter(this.round(totalPrincipal, 2))}</th>
    // 					<th>-</th>
    // 				</tr>
    // 			</tfoot>
    // 		</table>`;
    // 	let docfragment = document.createDocumentFragment();
    // 	docfragment.appendChild(document.createRange().createContextualFragment(output));
    // 	this.containerSchedule.appendChild(docfragment);
    // }
    CalculatorBotswanaPersonalLoan.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorBotswanaPersonalLoan.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorBotswanaPersonalLoan.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return valueFull + '.' + valueDecimal;
    };
    CalculatorBotswanaPersonalLoan.prototype.PMT = function (rate, nper, pv, fv, type) {
        if (fv === void 0) { fv = 0; }
        if (type === void 0) { type = 0; }
        if (rate === 0)
            return -(pv + fv) / nper;
        var pvif = Math.pow(1 + rate, nper);
        var pmt = rate / (pvif - 1) * -(pv * pvif + fv);
        if (type === 1) {
            pmt /= (1 + rate);
        }
        return pmt;
    };
    return CalculatorBotswanaPersonalLoan;
}(Base));
export { CalculatorBotswanaPersonalLoan };



//////////////////
// WEBPACK FOOTER
// ./components-botswana/calculator-botswana-personal-loan/calculator-botswana-personal-loan.component.ts
// module id = 789
// module chunks = 0